import {
  TPartSettingsTabKey,
} from '@/page/part/settings.ts';

const tabs: Record<TPartSettingsTabKey, string> = {
  attributes: 'Attributes',
  tableView: 'Overview table',
};

export default {
  tabs,
};
